import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import api from "@/lib/api";
import useSettings from "@/hooks/useSettings";
import useUiTexts, { uiText } from "@/lib/uiTexts";

/**
 * Contador público de interés por pieza (LIVE INTEREST COUNTER).
 * - Conectado a la DB real (GET /products/{id}/interest)
 * - Se actualiza solo: polling liviano cada 25s + refresco tras registrarse
 * - Animación minimalista cuando el número sube
 * - Modo de visualización (exacta/redondeada/indicador) controlado desde el panel
 */
export default function InterestCounter({ productId, bump }) {
  const settings = useSettings();
  const T = useUiTexts();
  const [d, setD] = useState(null);
  const [pulse, setPulse] = useState(0);
  const prev = useRef(null);

  useEffect(() => {
    let alive = true;
    const load = () => api.get(`/products/${productId}/interest`)
      .then((r) => {
        if (!alive) return;
        const val = r.data?.value || 0;
        if (prev.current != null && val > prev.current) setPulse((x) => x + 1);
        prev.current = val;
        setD(r.data);
      }).catch(() => {});
    load();
    const t = setInterval(load, 25000);
    return () => { alive = false; clearInterval(t); };
  }, [productId, bump]);

  if (!d || !d.label) return null;
  const isIndicator = (d.mode || (settings.counter_display || "exact")) === "indicator";

  return (
    <div data-testid="interest-counter" className="flex items-center gap-3 mt-5">
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#72B078] opacity-60" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-[#72B078]" />
      </span>
      <AnimatePresence>
        <motion.span
          key={pulse + d.label}
          initial={pulse > 0 ? { scale: 1.18, color: "#171719" } : { opacity: 0, y: 4 }}
          animate={{ scale: 1, color: "#565A61", opacity: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="dossier-label text-[11px] tracking-[0.18em]"
        >
          {isIndicator ? d.label : d.value === 0 ? uiText(T, "counter_zero") : d.label}
        </motion.span>
      </AnimatePresence>
    </div>
  );
}
